import React from 'react';
import { IReduxFormInput } from '../../../models/IReduxFormHandlers';
import { injectIntl } from 'react-intl';
import ReduxFormErrorHandler from './ReduxFormErrorHandler';

const ReduxFormInput: React.FC<IReduxFormInput> = props => {
  const errorClass = `${(props.meta.error && props.meta.touched) || props.meta.warning ? 'error' : ''}`;
   const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder; 

  let subStrArr = ["?", ">", "<", "'", ":", ";", ",", "+", "-", "(", ")", "*", "&", "^", "%", "$", "#", "{", "[", "]", "}", "|", "/", "="]
  if (props.type === 'email') {
    subStrArr = subStrArr.filter(subStr => subStr !== '-');
  }
  if (props.type === 'password') {
    subStrArr = subStrArr.filter(
      subStr => !['$', '%', '^', '&', '*', '+', '#', '"'].includes(subStr)
    );
  }
  return (
    <React.Fragment>
      <input
        {...props.input}
         placeholder={_placeholder} 
        //checked={props.checked}
        type={props.type}
        readOnly={props.readOnly}
        className={props.className + ' ' + errorClass}
        disabled={props.disabled}
        onChange={event => {
          if (event.target.type !== 'checkbox') {
            if (!props.spaceAllowed && (event.target.value === '' || !subStrArr.some((subStr: any) => event.target.value.includes(subStr)))) {
              props.input.onChange(event.target.value);
            } else if ((props.spaceAllowed === undefined || props.spaceAllowed) && (event.target.value === '' || !subStrArr.some((subStr: any) => event.target.value.includes(subStr)))) {
              props.input.onChange(event.target.value);
            }
          } else if (event.target.type === 'checkbox') {
            props.input.onChange(event.target.checked);
          }
        }}
      />
      <ReduxFormErrorHandler meta={props.meta} min={props.min} max={props.max} />
    </React.Fragment>
  );
};

export default injectIntl(ReduxFormInput);
